var chunkMapping = {
	"webpack_container_remote_Portal_CreateProject": [
		"webpack/container/remote/Portal/CreateProject"
	],
	"webpack_container_remote_ParadigmMF_FederatedAuthProvider": [
		"webpack/container/remote/ParadigmMF/FederatedAuthProvider"
	],
	"webpack_container_remote_SPECSHEET_SpecSheet": [
		"webpack/container/remote/SPECSHEET/SpecSheet"
	],
	"webpack_container_remote_SPECSHEET_SpecSheetViewer": [
		"webpack/container/remote/SPECSHEET/SpecSheetViewer"
	],
	"webpack_container_remote_PortalRelatedProjects_RelatedProjects": [
		"webpack/container/remote/PortalRelatedProjects/RelatedProjects"
	],
	"webpack_container_remote_SSM_SpecSheetManagerStandAlone": [
		"webpack/container/remote/SSM/SpecSheetManagerStandAlone"
	],
	"webpack_container_remote_SSM_SpecSheetManagerStandAloneConfigurator": [
		"webpack/container/remote/SSM/SpecSheetManagerStandAloneConfigurator"
	],
	"webpack_container_remote_SSM_SpecSheetManager": [
		"webpack/container/remote/SSM/SpecSheetManager"
	],
	"webpack_container_remote_SPECSHEET_TemplateManager": [
		"webpack/container/remote/SPECSHEET/TemplateManager"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/Portal/CreateProject": [
		"default",
		"./CreateProject",
		"webpack/container/reference/Portal"
	],
	"webpack/container/remote/ParadigmMF/FederatedAuthProvider": [
		"default",
		"./FederatedAuthProvider",
		"webpack/container/reference/ParadigmMF"
	],
	"webpack/container/remote/SPECSHEET/SpecSheet": [
		"default",
		"./SpecSheet",
		"webpack/container/reference/SPECSHEET"
	],
	"webpack/container/remote/SPECSHEET/SpecSheetViewer": [
		"default",
		"./SpecSheetViewer",
		"webpack/container/reference/SPECSHEET"
	],
	"webpack/container/remote/PortalRelatedProjects/RelatedProjects": [
		"default",
		"./RelatedProjects",
		"webpack/container/reference/PortalRelatedProjects"
	],
	"webpack/container/remote/SSM/SpecSheetManagerStandAlone": [
		"default",
		"./SpecSheetManagerStandAlone",
		"webpack/container/reference/SSM"
	],
	"webpack/container/remote/SSM/SpecSheetManagerStandAloneConfigurator": [
		"default",
		"./SpecSheetManagerStandAloneConfigurator",
		"webpack/container/reference/SSM"
	],
	"webpack/container/remote/SSM/SpecSheetManager": [
		"default",
		"./SpecSheetManager",
		"webpack/container/reference/SSM"
	],
	"webpack/container/remote/SPECSHEET/TemplateManager": [
		"default",
		"./TemplateManager",
		"webpack/container/reference/SPECSHEET"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}